module.exports = __webpack_public_path__ + "img/2018-trainingcenter.d1fb48e6.jpg";